import { NavLink, useNavigate } from 'react-router-dom';
import { IconInfoCircle, IconLogout } from '@tabler/icons-react';
import { useAuth } from '../../context/AuthContext';
import LogoBrand from '../ui/LogoBrand';
import { track } from '../../utils/analytics';
import './TopNav.scss';

const tabs = [
    { to: '/subscriptions', label: 'Подписки' },
    { to: '/account', label: 'Аккаунт' },
];

export default function TopNav() {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login', { replace: true });
    };

    return (
        <header className="top-nav">
            <NavLink to="/subscriptions" className="top-nav__logo">
                <LogoBrand variant="nav" />
            </NavLink>

            <nav className="top-nav__links">
                {tabs.map((tab) => (
                    <NavLink
                        key={tab.to}
                        to={tab.to}
                        end={tab.end}
                        onClick={() => track('nav_click', { target: tab.to })}
                        className={({ isActive }) =>
                            `top-nav__link${isActive ? ' top-nav__link--active' : ''}`
                        }
                    >
                        {tab.label}
                    </NavLink>
                ))}
            </nav>

            <div className="top-nav__actions">
                <NavLink
                    to="/links"
                    onClick={() => track('nav_click', { target: '/links' })}
                    className={({ isActive }) =>
                        `top-nav__info${isActive ? ' top-nav__info--active' : ''}`
                    }
                    aria-label="Информация"
                >
                    <IconInfoCircle size={20} stroke={1.5} />
                </NavLink>
                <button type="button" className="top-nav__logout" onClick={handleLogout}>
                    <IconLogout size={18} stroke={1.5} />
                    Выйти
                </button>
            </div>
        </header>
    );
}
